import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query ProjectsByGovernment($slug: String!, $cursor: Cursor, $limit: Int = 6) {
    projectsByGovernment(slug: $slug, cursor: $cursor, limit: $limit) {
      items {
        _id
        ...ProjectCardFields
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
